import React,{useEffect, useState} from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { RiBillLine } from 'react-icons/ri';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { Modal } from 'antd';
import toast from 'react-hot-toast';
import { DatePicker } from 'antd';
import { DeleteCaseService, GetCaseService,UploadCaseFile,UploadCaseDocsForCaseService, UpdateCaseHearingDateMassService } from '../../services/CaseService';
import CaseMenu from './CaseMenu';
import { TbUpload } from "react-icons/tb";
import { TextInput } from '../../components/input';
import Uploader from '../../components/Uploader';
import { useSelector } from 'react-redux';
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { BsCalendar2Date } from "react-icons/bs"

function CaseList() {

  const roles = useSelector(state=>state.Auth.roles)

  const [page,setpage] = useState(1)
  const [modal,setmodal] = useState(false)
  const [selectedmodal,setselectedmodal] = useState(false)
  const [uploadmodal,setuploadmodal] = useState(false)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [data,setdata] = useState({})  
  const [selecteddata,setselecteddata] = useState({}) 

  const [date,setdate] = useState('') 

  const [uploadData,setuploadData] = useState({file:'',name:''})
  const [error,seterror] = useState({file:'',name:''})

  const {pathname} = useLocation()
  const [selected,setselected] = useState([])

  const path = pathname?.split('/')[pathname?.split('/')?.length - 1]
   
  const [step,setstep] = useState(1)

  const steps = [
    'Pending',
    'In Progress',
    'Completed',
    'Hold',
  ]

  useEffect(()=>{
    getData()
  },[page,pathname,step])

  async function getData(){
    const response = await GetCaseService(page,search?.text,search?.from_date1,search?.to_date1,path == 'civil_court' ? 'Civil Court' : 'High Court',step)
    setdata(response?.data)
  }

  const navigate = useNavigate() 

  async function applyfilter(){
    const response = await GetCaseService(1,search?.text,search?.from_date1,search?.to_date1,path == 'civil_court' ? 'Civil Court' : 'High Court',step)
    setdata(response?.data)
  }

  async function UploadFile(e,name){
    const response = await UploadCaseFile({file:e})
    setuploadData({...uploadData,[name]:response?.data?.data,name:response?.data?.data})
  }

  async function resetfunc(){
    setpage(1)
    setsearch({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
    const response = await GetCaseService(1,'','','',path == 'civil_court' ? 'Civil Court' : 'High Court',step)
    setdata(response?.data)
  }  

  async function deleteData(){
    const response = await DeleteCaseService(selecteddata?._id)
    if(response?.status === 200){
      getData()
      setmodal(false)
      toast.success("Deleted Successfully!")
    }
  }

  async function handlechange(e){
    setuploadData({...uploadData,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function uploadDocsForCase(){
    const sendData = {...uploadData}
    sendData['case'] = selecteddata?._id
    const response = await UploadCaseDocsForCaseService(sendData)
    if(response?.status === 200){
      toast.success("File Uploaded Successfully!")
      setuploadmodal(false)
      setuploadData({file:'',name:''})
    }
  }

  async function setselectedfunction(v){
    
    if(selected.length <= 25){
      if(selected.length > 0){
        let oldData = [...selected]
        if(oldData?.includes(v)){
            setselected(oldData.filter((f)=>f !== v))
        }else{
            oldData.push(v)
            setselected(oldData)
        }   
      }else{
        let arr =[v]
        setselected(arr)
      }
    }else{
      toast.error("Selected Limit is just 25 case !")
    }

  }

  async function updateNextHearingDate(){
    if(selected?.length > 0){

      let sendData = {
        selected:selected,
        next_hearing_date:date
      }
      const response = await UpdateCaseHearingDateMassService(sendData)
      if(response?.status === 200){
          toast.success("Case Hearing Date Updated Successfully")
          setselectedmodal(false)
          setselected([])
      }
    }else{
      toast.error("No Case Selected to update the next hearing date!")
    }
  }




  return (
    <div className='md:flex pt-5 md:pt-0 '>
        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={modal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Delete Data</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to delete the selected Data</h6>
             
            <div className='my-1'>
               <h6 className='text-[11px]'>Client Info : <span className='font-[700]'>{selecteddata?.client?.name}</span></h6>
               <h6 className='text-[11px]'>Mobile : <span className='font-[700]'>{selecteddata?.client?.mobile}</span></h6>
            </div> 

            <h6 className='font-[700] text-[10px]'>case Info</h6>
            <div className='bg-slate-100 p-1'>
            <h6 className='text-[11px]'>Office File No : <span className='font-[500]'>{selecteddata?.office_file_no}</span></h6>
            <h6 className='text-[11px]'>Case No : <span className='font-[500]'>{selecteddata?.case_no}</span></h6>
            <h6 className='text-[11px]'>Parties Name : <span className='font-[500]'>{selecteddata?.parties_name}</span></h6>
            <h6 className='text-[11px]'>Advocated For : <span className='font-[500]'>{selecteddata?.advocate_for}</span></h6>

            </div>

            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>setmodal(false)} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={deleteData} />
            </div>
          </div>

        </Modal>

        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={uploadmodal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Upload Docs</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to upload the attachment for the selected case</h6>
             
         

            <h6 className='font-[700] text-[12px] mt-1'>case Info</h6>
            <div>
            <h6 className='text-[11px]'>Office File No : <span className='font-[500]'>{selecteddata?.office_file_no}</span></h6>
            <h6 className='text-[11px]'>Case No : <span className='font-[500]'>{selecteddata?.case_no}</span></h6>
            </div>


            <Uploader error={error?.file} name="file" required={true} label={'File'} image={uploadData?.file}  setimagefunc={(e)=>{UploadFile(e,'file');seterror({...error,file:''})}}  removeimageuploadfunc = {()=>{setuploadData({...uploadData,file:''});seterror({...error,file:''})}} />

            <TextInput 
              label={'File Name'}  
              variant="standard"
              name="name"
              type="text"
              value={uploadData.name}
              error={error.name}
              handlechange={handlechange}
              placeholder="Enter client name"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>



            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>setuploadmodal(false)} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={uploadDocsForCase} />
            </div>
          </div>

        </Modal>

        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={selectedmodal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Update Next Hearing Date</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to update the next hearing date for the selected (<span className='font-[800]'>{selected?.length}</span>) case</h6>
             

            <TextInput 
              label={'Next Hearing Date'}  
              variant="standard"
              name="name"
              type="date"
              value={date}
              handlechange={(e)=>setdate(e.target.value)}
              placeholder="Enter client name"
              InputLabelProps={{
                  style: { color: '#fff', }, 
              }}/>



            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>{setselectedmodal(false);setselected([])}} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={updateNextHearingDate} />
            </div>
          </div>

        </Modal>

        <CaseMenu />
        <div className='md:w-[87%] px-4 pt-2 md:pt-2'>
        <div className='flex flex-col md:flex-row border-b pb-2 border-slate-200 w-[100%] md:items-center justify-between'>
          
        <div className='flex items-center justify-between'>
          <h6 className='font-[600] text-[14px] '>{`Total ${path === 'civil_court' ? 'Civil' : 'High'} Case`} ({data?.pagination?.total})</h6>

          <div className='flex md:hidden items-center mt-2'>
            <div className='flex md:hidden items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
        </div>    
        </div>


        <div className='flex flex-col md:flex-row md:items-center mt-2'>

        <div className='hidden md:flex items-center  text-[12px] mr-2'>

        <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
        <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>
        <div>
        <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
        <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

        </div>
        </div>

          <div className='flex'>
          <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

          <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 

            
            <input id="search_text" placeholder='Search ...' type='text' value={search?.text}  onChange={(e)=>setsearch({...search,text:e.target.value})} className='border text-sm py-[4px] focus:ring-0  focus:outline-0 text-[13px]  w-28 px-1 rounded-md border-slate-300' />
          </div>
         
          <div className="mt-2 md:mt-0 md:ml-2 flex">
          <ButtonOutlinedAutoWidth onClick={()=>{setpage(1);applyfilter()}}  btnName="Add Filter" />

          <div className="ml-2">
          <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
          </div> 

          {selected?.length > 0 && <BsCalendar2Date size={26} className='bg-slate-200 p-1.5 ml-1 text-black rounded'  onClick={()=>{setselectedmodal(true)}} />}
          </div> 
        </div>  


       </div>
       <div className='border-b flex items-center'>
       {steps?.map((s,i)=>(
        <h6 onClick={()=>{setstep(i+1);setpage(1)}} className={` ${step === i+1 ? 'bg-[#1b3f69] text-white' : ''} cursor-pointer px-2 p-1.5 text-[10px] font-[600]`}>{s}</h6>
       ))}
       </div>
       
       
        {data?.datas?.length === 0 &&
            <div className='grid place-items-center mt-20  items-center justify-center'>
            <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
            <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
            <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
          </div>
          }

          {data?.datas?.length > 0 &&
          <div className='md:max-h-[82vh] overflow-x-scroll md:overflow-x-hidden md:w-[100%] mt-4 border-t border-l border-r md:overflow-y-scroll'>
            <div className='sticky top-0 z-50 w-max md:w-[100%] flex  py-[-5px] border-b border-slate-200 relative'>
                <h6  className='sticky top-0  z-50 text-[12px] w-[50px] min-w-[50px] md:w-[6%]  px-2 py-1 font-[600] text-slate-600 border-r flex items-center justify-center'>
                  {/* Sl No */}
                  </h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[150px] min-w-[150px] md:w-[15%]  px-2 py-1 font-[600] text-slate-600 border-r'>Client Info</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[120px] min-w-[120px] md:w-[10%]  px-2 py-1 font-[600] text-slate-600 border-r'>Office File No</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[120px] min-w-[120px] md:w-[10%] px-2 py-1 font-[600] text-slate-600 border-r'>Case No</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[140px] min-w-[140px] md:w-[12%] px-2 py-1 font-[600] text-slate-600 border-r'>Parties Name</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[140px] min-w-[140px] md:w-[12%] px-2 py-1 font-[600] text-slate-600 border-r'>Advocate For</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[120px] min-w-[120px] md:w-[9%] px-2 py-1 font-[600] text-slate-600 border-r'>Court Hall</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[120px] min-w-[120px] md:w-[9%] px-2 py-1 font-[600] text-slate-600 border-r'>Stage</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[100px] min-w-[100px] md:w-[6%] px-2 py-1 font-[600] text-slate-600 border-r'>Floor</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[80px] min-w-[80px] md:w-[14%] md:min-w-[14%]  px-2 py-1 font-[600] text-slate-600 '>Actions</h6>
            </div>
            {data?.datas?.map((d,i)=>(
            <div className='flex py-[-5px] w-max md:w-[100%] border-b border-slate-200 relative'>
                <h6 onClick={()=>setselectedfunction(d?._id)} className='bg-white truncate z-50 text-[12px] w-[50px] min-w-[50px] md:w-[6%]  px-2 py-1 text-black border-r flex items-center justify-center'>
                  {/* {page == 1 ? i+1 : (data?.pagination?.limit * (page - 1)) + (i+1)} */}
                  {!selected?.includes(d?._id) ? <BiCheckbox className='text-gray-300' size={18} /> : <BiCheckboxSquare className='text-slate-600' size={18} />}
                </h6>
                <h6 className='text-[12px] truncate w-[150px] min-w-[150px] md:w-[15%]  px-2 py-1 opacity-70  text-black border-r'>{d?.client?.name} / {d?.client?.mobile}</h6>
                <h6 className='text-[12px] truncate w-[120px] min-w-[120px] md:w-[10%]  px-2 py-1  opacity-70 text-black border-r'>{d?.office_file_no}</h6>
                <h6 className='text-[12px] truncate w-[120px] min-w-[120px] md:w-[10%]  px-2 py-1 opaci ty-70  text-black border-r'>{d?.case_no}</h6>
                <h6 className='text-[12px] truncate w-[140px] min-w-[140px] md:w-[12%] px-2 py-1  opacity-70 text-black border-r'>{d?.parties_name} </h6>
                <h6 className='text-[12px] truncate w-[140px] min-w-[140px] md:w-[12%] px-2 py-1  opacity-70 text-black border-r'>{d?.advocate_for}</h6>
                <h6 className='text-[12px] truncate w-[120px] min-w-[120px] md:w-[9%] capitalize  px-2 py-1  opacity-70 text-black border-r'>{d?.court_hall}</h6>
                <h6 className='text-[12px] truncate w-[120px] min-w-[120px] md:w-[9%] px-2 py-1  opacity-70 text-black border-r'>{d?.stage?.name}</h6>
                <h6 className='text-[12px] truncate w-[100px] min-w-[100px] md:w-[6%] px-2 py-1  opacity-70 text-black border-r'>{d?.floor}</h6>
                <h6 className='text-[12px] flex truncate w-[80px] min-w-[80px] md:w-[14%]  -ml-1 px-2 py-1  opacity-70 text-black '>
                  <RiBillLine className='mr-2' onClick={()=>navigate('detail',{state:d})} />
                  <BsCalendar2Date className='mr-2' onClick={()=>{setselected([d?._id]);setselectedmodal(true)}} />
                  <TbUpload className='mr-2' onClick={()=>{setselecteddata(d);setuploadmodal(true)}} />
                  <AiOutlineEdit className='mr-2' onClick={()=>{navigate('edit',{state:d})}} />
                  {['admin','Admin']?.filter((f)=>roles?.includes(f))?.length > 0 &&
                  <AiOutlineDelete onClick={()=>{setselecteddata(d);setmodal(true)}} />}
                </h6>
            </div>))}
          </div>}
       </div>
       
    </div>
  )
}

export default CaseList